/** Match web POC: treat 401/403 SAS failures as non-fatal for optional blobs. */
export function defaultIgnorableSasFetchError(error: unknown): boolean {
  const msg = error instanceof Error ? error.message : String(error);
  return /\b403\b/.test(msg) || /\b401\b/.test(msg);
}
